import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";

const SiteMapPage = () => {
  let currentYear = new Date().getFullYear();
  let years = [];
  for (let i = 2006; i <= currentYear; i++) {
    years.push(i);
  }
  return (
    <div className="container">
      <div className={styles["sitemap-wrapper"]}>
        <h1 className={styles["header"]}>Site Map</h1>
        <ol className={styles["o-list-index"]}>
          {years.map((year, index) => (
            <li key={index} className={styles["list"]}>
              <Link href={`/site-map/${year}`}>{year}</Link>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
export { SiteMapPage };
